/* Firenze Table: native Shopify storefront interactions. */
(() => {
  const searchPanel = document.querySelector('#SearchPanel');
  const menu = document.querySelector('#MobileMenu');
  const scrim = document.querySelector('.menu-scrim');
  let menuOpener;
  const closeMenu = () => {
    if (!menu) return;
    menu.hidden = true;
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('menu-open');
    document.querySelectorAll('[data-menu-toggle]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    menuOpener?.focus();
  };
  document.querySelectorAll('[data-menu-toggle]').forEach(button => button.addEventListener('click', () => {
    if (!menu) return;
    if (!menu.hidden) { closeMenu(); return; }
    menuOpener = button;
    menu.hidden = false;
    if (scrim) scrim.hidden = false;
    document.body.classList.add('menu-open');
    document.querySelectorAll('[data-menu-toggle]').forEach(el => el.setAttribute('aria-expanded', 'true'));
    menu.querySelector('button, a')?.focus();
  }));
  document.querySelectorAll('[data-search-toggle]').forEach(button => button.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.hidden = !searchPanel.hidden;
    document.querySelectorAll('[data-search-toggle]').forEach(el => el.setAttribute('aria-expanded', String(!searchPanel.hidden)));
    if (!searchPanel.hidden) searchPanel.querySelector('input[type="search"]')?.focus();
  }));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (menu && !menu.hidden) closeMenu();
      if (searchPanel && !searchPanel.hidden) {
        searchPanel.hidden = true;
        document.querySelector('[data-search-toggle]')?.focus();
        document.querySelectorAll('[data-search-toggle]').forEach(el => el.setAttribute('aria-expanded', 'false'));
      }
      document.querySelectorAll('.nav-dropdown[open], .filter-dropdown[open]').forEach(el => el.removeAttribute('open'));
    }
    if (event.key === 'Tab' && menu && !menu.hidden) {
      const focusable = [...menu.querySelectorAll('button, a, summary')].filter(el => el.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('click', event => document.querySelectorAll('.nav-dropdown[open], .filter-dropdown[open]').forEach(el => {
    if (!el.contains(event.target)) el.removeAttribute('open');
  }));
  document.querySelectorAll('[data-quantity-change]').forEach(button => button.addEventListener('click', () => {
    const input = button.closest('.quantity-control').querySelector('input');
    const minimum = Number(input.min || 0);
    const maximum = input.max ? Number(input.max) : Infinity;
    input.value = Math.min(maximum, Math.max(minimum, (Number(input.value) || minimum) + Number(button.dataset.quantityChange)));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  document.querySelectorAll('[data-sort-by]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
  const product = document.querySelector('[data-product-root]');
  if (!product) return;
  const variantData = product.querySelector('[data-product-variants]');
  const variants = variantData ? JSON.parse(variantData.textContent) : [];
  const form = product.querySelector('[data-product-form]');
  if (form) form.querySelector('[data-variant-id]').disabled = false;
  const mainImage = product.querySelector('.product-main-image');
  const imageDialog = product.querySelector('[data-image-dialog]');
  const updateImage = (src, imageId) => {
    if (!src || !mainImage) return;
    mainImage.src = src;
    mainImage.removeAttribute('srcset');
    if (imageDialog) imageDialog.querySelector('img').src = src;
    product.querySelectorAll('[data-product-thumb]').forEach(button => {
      const active = String(button.dataset.imageId) === String(imageId);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  };
  product.querySelectorAll('[data-product-thumb]').forEach(button => button.addEventListener('click', () => updateImage(button.dataset.image, button.dataset.imageId)));
  product.querySelector('[data-open-image]')?.addEventListener('click', () => imageDialog?.showModal());
  product.querySelector('[data-close-image]')?.addEventListener('click', () => imageDialog?.close());
  imageDialog?.addEventListener('click', event => { if (event.target === imageDialog) imageDialog.close(); });
  const money = cents => {
    const amount = cents / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.Shopify?.currency?.active || 'AUD' }).format(amount);
  };
  const options = [...product.querySelectorAll('[data-option-index]')];
  const updateVariant = () => {
    const selected = options.map(select => select.value);
    const variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
    const button = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const accelerated = form.querySelector('.dynamic-checkout');
    const hiddenId = form.querySelector('[data-variant-id]');
    const status = form.querySelector('[data-variant-status]');
    button.disabled = !variant?.available;
    label.textContent = variant ? (variant.available ? 'Add to cart' : 'Sold out') : 'Unavailable';
    status.textContent = variant ? (variant.available ? '' : 'This option is currently sold out.') : 'This combination is not available. Please choose another option.';
    if (accelerated) accelerated.hidden = !variant?.available;
    hiddenId.disabled = !variant;
    if (!variant) return;
    hiddenId.value = variant.id;
    hiddenId.dispatchEvent(new Event('change', { bubbles: true }));
    const price = product.querySelector('[data-product-price]');
    price.replaceChildren();
    const current = document.createElement('span');
    current.textContent = money(variant.price);
    price.append(current);
    if (variant.compare_at_price > variant.price) {
      const compare = document.createElement('s');
      compare.textContent = money(variant.compare_at_price);
      price.append(compare);
    }
    product.querySelector('[data-product-sku]').textContent = variant.sku || 'Not specified';
    if (variant.featured_image) updateImage(variant.featured_image.src, variant.featured_image.id);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };
  options.forEach(select => select.addEventListener('change', updateVariant));
  form?.addEventListener('submit', async event => {
    if (event.submitter && event.submitter.name !== 'add') return;
    event.preventDefault();
    const button = form.querySelector('[data-add-button]');
    const label = form.querySelector('[data-add-label]');
    const message = form.querySelector('[data-product-message]');
    button.disabled = true;
    label.textContent = 'Adding...';
    message.hidden = true;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added. Please try again.');
      message.replaceChildren(document.createTextNode('Added to your cart. '));
      const cartLink = document.createElement('a');
      cartLink.href = (window.Shopify?.routes?.root || '/') + 'cart';
      cartLink.textContent = 'View cart';
      message.append(cartLink);
      message.classList.remove('is-error');
      message.hidden = false;
      label.textContent = 'Added to cart';
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } }).then(res => res.json()).then(cart => {
        document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
        document.querySelectorAll('.cart-link').forEach(el => el.setAttribute('aria-label', `Cart, ${cart.item_count} items`));
      }).catch(() => {});
    } catch (error) {
      message.textContent = error.message || 'Unable to add this piece. Please try again.';
      message.classList.add('is-error');
      message.hidden = false;
      label.textContent = 'Add to cart';
    } finally { button.disabled = false; }
  });
})();
